import { useState } from 'react';
import api from "../utils/api";


export default function PlaceOptionOrderCard({ userId, defaultOCC = '' }) {
    const [optionSymbol, setOptionSymbol] = useState(defaultOCC);
    const [side, setSide] = useState('buy_to_open');
    const [qty, setQty] = useState(1);
    const [type, setType] = useState('market');
    const [duration, setDuration] = useState('day');
    const [price, setPrice] = useState('');
    const [preview, setPreview] = useState(true);
    const [msg, setMsg] = useState('');


    const place = async () => {
        try {
            const payload = {
                user_id: userId,
                option_symbol: optionSymbol.trim(),
                side, quantity: Number(qty), type, duration,
                preview,
            };
            if (type !== 'market') payload.price = Number(price);
            const { data } = await api.post('/api/options/tradier/place', payload);
            setMsg(JSON.stringify(data));
        } catch (e) { setMsg('Order failed'); }
    };


    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Options (Tradier)</h3>
            <input className="px-3 py-2 rounded bg-zinc-800 w-full" placeholder="OCC symbol e.g. AAPL250117C00150000" value={optionSymbol} onChange={e => setOptionSymbol(e.target.value)} />
            <div className="grid grid-cols-2 gap-2">
                <select className="px-3 py-2 rounded bg-zinc-800" value={side} onChange={e => setSide(e.target.value)}>
                    <option>buy_to_open</option>
                    <option>buy_to_close</option>
                    <option>sell_to_open</option>
                    <option>sell_to_close</option>
                </select>
                <input type="number" className="px-3 py-2 rounded bg-zinc-800" value={qty} onChange={e => setQty(Number(e.target.value))} />
                <select className="px-3 py-2 rounded bg-zinc-800" value={type} onChange={e => setType(e.target.value)}>
                    <option>market</option>
                    <option>limit</option>
                    <option>stop</option>
                    <option>stop_limit</option>
                </select>
                <select className="px-3 py-2 rounded bg-zinc-800" value={duration} onChange={e => setDuration(e.target.value)}>
                    <option value="day">day</option>
                    <option value="gtc">gtc</option>
                </select>
                {type !== 'market' && (
                    <input className="px-3 py-2 rounded bg-zinc-800 col-span-2" placeholder="Price" value={price} onChange={e => setPrice(e.target.value)} />
                )}
            </div>
            <label className="flex items-center gap-2 text-sm text-zinc-300">
                <input type="checkbox" checked={preview} onChange={e => setPreview(e.target.checked)} /> Preview before sending
            </label>
            <button onClick={place} className="px-4 py-2 rounded bg-blue-600">Submit</button>
            {msg && <pre className="text-xs text-zinc-300 overflow-auto max-h-48">{msg}</pre>}
        </div>
    );
}